// 导入 types.js 文件
import types from "../types";


const state = {
	logininfo: JSON.parse(localStorage.getItem("logininfo")) || {},
}

// 定义 getters
var getters = {
	logininfo(state) {
		return state.logininfo
	}

}

const actions = {
	LOGININFO({
		commit
	}) {
		// 此处提交的事件与下方 mutations 中的 types.TPEOPLE 对应
		//与原来 commit('tpeople') 的原理相同，只是把类型名换成了常量
		commit(types.LOGININFO)
	}
}

const mutations = {
	// 此处的事件为上方 actions 中的 commit(types.TPEOPLE)
	[types.LOGININFO](state, data) {
		if (data) {
			localStorage.setItem("logininfo", JSON.stringify(data));
			state.logininfo = data;
		} else {
			localStorage.removeItem("logininfo");
			state.logininfo = '';
		}

	}
}
// 最后统一导出
export default {
	state,
	getters,
	actions,
	mutations
}